import { IActionButton } from '~src/commonInfra/contentActions/ActionPanelInterfaces';
import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext,
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { Set } from '~src/ts/models/Set';
import { DownloadActions } from '~src/ts/services/download/DownloadActions';

import { IContentRevision } from '../serverApi/types/IContentRevision';

export namespace RevisionActions {
  export function downloadContentRevisionAction(): RevisionHistoryActionButton<IContentRevision> {
    return {
      name: 'download',
      translate: 'download_action',
      execute: (context: RevisionHistoryActionContext<IContentRevision>) => {
        DownloadActions.downloadContentRevision(context.selectedItem);
      }
    };
  }
  export function downloadContentRevisionActionAngular(): IActionButton<IContentRevision, {}> {
    return {
      name: 'download',
      translate: 'download_action',
      isAvailable: (items: Set<IContentRevision>) => true,
      execute: (items: Set<IContentRevision>) => {
        DownloadActions.downloadContentRevision(items.first());
      }
    };
  }
}
